import { FC } from "react"
import { UseFormRegister, FieldValues, FieldErrors, FieldError } from "react-hook-form"
import { FormbuilderInput } from "../formbuilder-input"

interface StringFormProps {
    register: UseFormRegister<FieldValues>
    errors: FieldErrors<FieldValues>
}

export const StringForm: FC<StringFormProps> = ({ register, errors }) => {
    return (
        <>
            <FormbuilderInput
                register={register}
                label={"Минимальная длина"}
                id={"min_length"}
                error={errors['min_length'] as FieldError}
                type="text"
                required={true}
                placeholder="Введите минимальную длину"
            />
            <FormbuilderInput
                register={register}
                label={"Максимальная длина"}
                id={"max_length"}
                error={errors['max_length'] as FieldError}
                type="text"
                required={true}
                placeholder="Введите максимальную длину"
            />
        </>
    )
}
